class BaseException {
    constructor(message){
        this.message = message;
        window.console.error(this.message);
    }
}

class InvalidArgumentException extends BaseException {}

class AbstractException extends BaseException {}

class ClassDoesNotExistException extends BaseException {}

export {BaseException, InvalidArgumentException, AbstractException, ClassDoesNotExistException};






// WEBPACK FOOTER //
// ./src/embed/Exceptions.es6